/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Col_TossInputs */



/**
* | output |
* | --- |
* | "Toss" |
*
* @param {Tournament_Col_TossInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_col_toss = /** @type {((inputs?: Tournament_Col_TossInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Col_TossInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tirage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sorteo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Toss")
	if (locale === "it") return /** @type {LocalizedString} */ ("Toss")
	return /** @type {LocalizedString} */ ("Toss")
});